import {
  GET_CUTOMER_PRIORITY_REQUEST,
  GET_CUTOMER_PRIORITY_SUCCESS,
  GET_CUTOMER_PRIORITY_ERROR,
} from "./types.js";
import { BASEURL } from "../../constant/config.js";

const axios = require("axios");


export const getAllCustomerPriority = (token) => (dispatch) => {
  dispatch({ type: GET_CUTOMER_PRIORITY_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/customerPriority`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {
      return dispatch({ type: GET_CUTOMER_PRIORITY_SUCCESS, payload: response.data });
    })
    .catch((error) => {
      return dispatch({
        type: GET_CUTOMER_PRIORITY_ERROR,
        payload: error.response,
      });
    });
};

